<template>
    <div>
        <v-dialog v-model="previewDialog" max-width="900" eager>
            <v-card flat>
                <v-toolbar dark dense flat color="blue darken-2">
                    <v-toolbar-title> Préviews</v-toolbar-title>
                </v-toolbar>
                <v-divider/>
                <v-card-text>
                    <v-row dense>
                        <v-col cols="12">
                            <preview-model
                                    v-if="!freeMode"
                                    :modelId="modelId"
                                    :file="file"
                            ></preview-model>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>
        </v-dialog>

        <v-form ref="form" lazy-validation>
            <v-row>
                <v-col cols="12" v-if="!freeMode">
                    <str-import-model-select
                            v-model="modelId"
                            :rules="[mxRules.required]"
                    ></str-import-model-select>
                </v-col>

                <v-col cols="12">
                    <v-file-input
                            v-model="file"
                            label="Jointer Fichier Excel"
                            dense
                            outlined
                            :prepend-icon="''"
                            :prepend-inner-icon="'mdi-paperclip'"
                            clearableb
                            :background-color="backgroundColor"
                            :color="inputColor"
                            hide-details="auto"
                            accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                            :rules="[mxRules.required]"
                    ></v-file-input>
                </v-col>
                <v-col cols="12">
                    <v-checkbox
                            v-model="addZeroValue"
                            label="Importer même si la valeur égale à 0"
                            color="orange"
                            class="mt-n1"
                            hide-details
                    ></v-checkbox>
                </v-col>
                <v-col cols="12">
                    <v-radio-group
                            v-model="updateOption"
                            column
                            hide-details
                            class="mt-n2"
                    >
                        <v-radio value="KEEP" label="Garder" color="blue"/>
                        <v-radio value="ERASE" label="Remplacer" color="red"/>
                        <v-radio value="SUM" label="Cumuler" color="teal"/>
                    </v-radio-group>
                </v-col>
                <v-col cols="6">
                    <v-btn
                            v-if="!freeMode"
                            depressed
                            block
                            class="white--text"
                            color="blue"
                            @click="previewDialog = true"
                    >
                        <v-icon left>mdi-cube-scan</v-icon>
                        Aperçu
                    </v-btn>
                    <preview-file-free-mode
                            v-else
                            :file="file"
                            :annex-id="annexId"
                            :add-zero-value="addZeroValue"
                    ></preview-file-free-mode>
                </v-col>
                <v-col cols="6">
                    <v-btn
                            depressed
                            block
                            dark
                            color="teal"
                            :loading="loading"
                            @click="save"
                    >
                        Importer
                    </v-btn>
                </v-col>
            </v-row>
        </v-form>
    </div>
</template>

<script>
import StrImportModelSelect from "@/views/ImportModel/Components/StrImportModelSelect.vue";
import PreviewModel from "@/views/ImportModel/Components/PreviewModel.vue";
import PreviewFileFreeMode from "@/views/PaySectionImport/Components/PreviewFileFreeMode.vue";
import useValidation from "@/use/Validation.js";
import useSharedMethod from "@/use/SharedMethod.js";
import useTools from "@/use/Tools.js";
import {usePaySlipStore} from "@/stores/PaySlip.js";
import useSharedData from "@/use/SharedData.js";
import {ref} from "vue";
import axios from "axios";

export default {
    components: {PreviewFileFreeMode, StrImportModelSelect, PreviewModel},
    props: {
        filter: Object,
        workers: Array,
        annexId: Number,
        freeMode: Boolean,
    },
    setup(props) {
        const {mxRules} = useValidation();
        const {getBack} = useSharedMethod();
        const {$refs} = useTools();
        const {loading, inputColor, backgroundColor} = useSharedData();
        const paySlipStore = usePaySlipStore();
        const previewDialog = ref(false);
        const file = ref(null);
        const modelId = ref(null);
        const addZeroValue = ref(false);
        const updateOption = ref('KEEP');

        function save() {
            if ($refs.form.validate()) {
                loading.value = true;
                const formData = new FormData();
                formData.append("file", file.value);
                const url = `/payments/${props.freeMode ? 'addFileFreeModePaySections' : 'addFileModelPaySections'}`;
                axios.put(url, formData, {
                    params: {
                        annexId: props.annexId,
                        updateOption: updateOption.value,
                        importModelId: modelId.value,
                        addZeroValue: addZeroValue.value
                    },
                }).then(response => {
                    paySlipStore.updateAll(response.data);
                    getBack();
                }).finally(() => {
                    loading.value = false;
                });
            }
        }

        return {
            mxRules,
            previewDialog,
            loading,
            inputColor,
            backgroundColor,
            file,
            modelId,
            addZeroValue,
            updateOption,
            save
        }
    }
};
</script>